export function formatTranslation(template, vars = {}) {
  if (!template) return '';
  return Object.entries(vars).reduce(
    (text, [key, value]) => text.replace(new RegExp(`\\{${key}\\}`, 'g'), String(value ?? '')),
    template,
  );
}

export function translateFromStorage(key, vars = {}) {
  try {
    // eslint-disable-next-line global-require
    const { TRANSLATIONS } = require('../context/LanguageContext');
    const lang = localStorage.getItem('developmentexpress_lang') || 'en';
    const template = TRANSLATIONS[lang]?.[key] ?? TRANSLATIONS.en?.[key] ?? key;
    return formatTranslation(template, vars);
  } catch (_err) {
    return key;
  }
}
